module.exports = __webpack_public_path__ + "static/img/5.9afac28.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/eng/5.png
// module id = rCWJ
// module chunks = 0